import './AccordionItem.css';
import React from 'react';
import { get, injectImageResolution } from '../../utils';
import { Text, RichText } from '@sitecore-jss/sitecore-jss-react';
import { ReactComponent as IconPlus } from '../../resources/icons/accordion-plus.svg';
import { ReactComponent as IconMinus } from '../../resources/icons/accordion-minus.svg';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import LazyPicture from '../atoms/LazyPicture';
var BASE_URL = process.env.REACT_APP_MEDIA_HOST ? process.env.REACT_APP_MEDIA_HOST : '';
export var AccordionItem = function AccordionItem(_ref) {
  var isActive = _ref.isActive,
    item = _ref.item,
    pageEditing = _ref.pageEditing,
    onChange = _ref.onChange;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var titleField = get(item, 'title.jss');
  var description = get(item, 'description.jss');
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, /*#__PURE__*/React.createElement("div", {
    className: "accordion-item ".concat(isActive ? "accordion-item--active" : ""),
    key: item.id
  }, /*#__PURE__*/React.createElement("p", {
    className: "accordion-item__heading body-medium",
    onClick: function onClick(e) {
      if (!pageEditing) {
        e.preventDefault();
        onChange && onChange(e);
      }
    },
    onKeyPress: function onKeyPress(e) {
      if (e.key === " " || e.key === "Spacebar") {
        e.preventDefault();
        onChange && onChange(e);
      }
    }
  }, /*#__PURE__*/React.createElement(Text, {
    tag: pageEditing ? 'span' : 'a',
    className: "accordion-item__anchor",
    href: "/",
    field: titleField,
    "data-cy": "accordion-faq-anchor"
  }), !pageEditing && /*#__PURE__*/React.createElement("span", {
    className: "accordion-item__icon"
  }, isActive ? /*#__PURE__*/React.createElement(IconMinus, null) : /*#__PURE__*/React.createElement(IconPlus, null))), isActive && /*#__PURE__*/React.createElement("div", {
    className: "accordion-item__content"
  }, item.image && get(item.image, "jss.value.src") && /*#__PURE__*/React.createElement(LazyPicture, {
    className: "accordion-item__img"
  }, /*#__PURE__*/React.createElement("source", {
    srcSet: item.image.jss.value.src ? injectImageResolution("".concat(BASE_URL).concat(item.image.jss.value.src), 580, 240) : "",
    media: "(min-width: 768px)"
  }), /*#__PURE__*/React.createElement("img", {
    src: item.image.jss.value.src ? injectImageResolution("".concat(BASE_URL).concat(item.image.jss.value.src), 1005, 540) : "",
    alt: item.image.jss.value.alt
  })), /*#__PURE__*/React.createElement(RichText, {
    tag: "p",
    className: "body-small accordion-item__desc",
    field: description,
    "data-cy": "accordion-faq-item-content"
  }))));
};
var commonStyles = "cgn4e1k";
var rtlStyles = "rnxugok";
var ltrStyles = "l1siopd0";